"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filters = void 0;
const vue_1 = __importDefault(require("vue"));
const transcode_1 = __importDefault(require("./transcode"));
exports.filters = {
    transcode: transcode_1.default
};
Object.keys(exports.filters).forEach((key) => {
    vue_1.default.filter(key, exports.filters[key]);
});
